import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTimeRepeat = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "2.5em",
	height: "2.5em",
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M19 13V20C19 20.2652 19.1054 20.5196 19.2929 20.7071C19.4804 20.8946 19.7348 21 20 21H27V19H21V13H19Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M20 8C16.8185 8.00344 13.7682 9.26883 11.5185 11.5185C9.26883 13.7682 8.00344 16.8185 8 20H10C9.9982 17.743 10.7587 15.5516 12.1583 13.7809C13.5579 12.0103 15.5145 10.7643 17.7109 10.2449C19.9073 9.72544 22.2148 9.96306 24.2592 10.9192C26.3036 11.8754 27.9652 13.494 28.9746 15.5127C29.9839 17.5314 30.2819 19.8319 29.8201 22.0411C29.3584 24.2504 28.164 26.2389 26.4307 27.6844C24.6973 29.1298 22.5265 29.9475 20.2702 30.0048C18.014 30.0621 15.8045 29.3556 14 28L15.8 25.6L8.6 25.2L11 32L12.8 29.594C14.3208 30.7366 16.0914 31.5013 17.9659 31.825C19.8403 32.1487 21.7648 32.0221 23.5808 31.4558C25.3967 30.8895 27.0519 29.8995 28.4101 28.5677C29.7682 27.2358 30.7902 25.6002 31.3919 23.7957C31.9935 21.9912 32.1576 20.0695 31.8706 18.1891C31.5835 16.3087 30.8535 14.5234 29.7409 12.9806C28.6282 11.4378 27.1647 10.1816 25.471 9.31566C23.7774 8.44969 21.9022 7.99874 20 8Z",
		fill: "currentColor"
	})]
});
const ForwardRef = forwardRef(SvgTimeRepeat);
export default ForwardRef;
